import React from 'react';
import { Link } from 'react-router-dom';
import { HStack, Text } from '@chakra-ui/react';
import styled from '../../../consts/styled';

import { MediaTypeIcon } from '../../../scripts/getMediaTypeIcon';
import { Pinning as PinningType } from '../hooks/api/types';
import { trackAction } from '../../../helpers/trackAction';
import { User } from '../../../context/AuthProvider';

interface PinningProps {
  route: string;
  obj: PinningType;
  showDetails?: boolean;
  user: User;

  className: string;
}

const Pinning: React.FC<PinningProps> = (props) => {
  const { route, obj, showDetails = true, user } = props;

  return (
    <Link
      className={props.className}
      onClick={() => {
        trackAction(
          {
            action_type: 'opened_pinned',
            action_object: {
              type: 'content',
              pk: obj.content.id,
            },
            // @ts-expect-error
            study_group: { pk: obj.studyGroup.id },
          },
          user.user_actions,
        );
      }}
      to={route}
      title={obj.content.name}
    >
      <HStack className={'v-center'} spacing={0} gap={4}>
        <MediaTypeIcon mediaType={obj.content.mediaType} boxSize="24px" />
        <Text
          as="span"
          textStyle="bodyMedium"
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
        >
          {obj.content.name}
        </Text>
      </HStack>
      {showDetails ? (
        <HStack className={'details'}>
          {
            // content:
            obj.content.module ? (
              <span title={obj.content.module.unit.program?.name}>
                {obj.content.module.unit.program?.name}
              </span>
            ) : null
          }
          {obj.content.module?.unit ? (
            <span title={obj.content.module.unit?.name}>
              {obj.content.module.unit?.name}
            </span>
          ) : null}
          {obj.content.module ? (
            <span title={obj.content.module?.name}>
              {obj.content.module?.name}
            </span>
          ) : null}

          {
            // guide:
            obj.content.program ? (
              <span title={obj.content.program?.name}>
                {obj.content.program?.name}
              </span>
            ) : null
          }
        </HStack>
      ) : null}
    </Link>
  );
};

export const PinningComponent = styled(Pinning as any)<
  Omit<PinningProps, 'className'>
>`
  cursor: pointer;
  border-radius: 4px;
  transition: box-shadow 0.3s ease-out, transform 0.3s ease-out,
    background-color 0.3s ease-out;
  transition-delay: 0.1s;
  transform: translateY(0);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  margin-bottom: 16px;
  padding: 16px;
  max-width: 100%;

  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.15);
    background-color: #d5d6de33;
    transform: translateY(-2px);
  }

  .details {
    color: #8e8fa2;
    margin-top: 8px;
    span {
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1 1 33.33333%;
      width: 33.33333%;

      &:not(:last-of-type) {
        margin-right: 3px;
      }
    }
  }
`;
